import "./MediaComp.css";
import { useContext } from "react";
import { usePreference } from "../../../context/usePreference";
import { renderTableFirstGrid } from "./MediaCompUtils";
import * as FaIcons from "react-icons/fa";
import { UiContext } from "../../../context/UiContext";

export function MediaCompRowFirst({ rowContent, rowID, Indice, onDelete, isAutoUpdate }) {
  const row = rowContent;
  const KeyDeleteMC = Indice + "|" + rowContent[3];
  const u = usePreference();
  const Target = u.userPreference?.Target.Id;
  const { updateElementRects } = useContext(UiContext);

  let classColor = "tableRow";

  if (rowID % 2 !== 0) {
    classColor += " even";
  }

  if (rowContent[0] === '0' && rowContent[2] === "") {
    classColor = classColor.replace(" even", ""); // Remove "even" se existir
    classColor += " tableRowAlert2";
  }

  if (Indice > 2) {
    classColor += " dobleIndice";
  }

  async function handleDeleteMC(KeyDeleteMC) {
    onDelete(KeyDeleteMC);
    updateElementRects(document.querySelector('#minuteGraphic'), document.querySelector('#DivMedComp'));
  }

  return (
    <>
      <tr className={classColor} style={{ height: '25px' }}>
        <td colSpan={2} style={{ backgroundColor: '#001e78', color: 'white', borderRight: '1px solid white' }}>

          {!isAutoUpdate &&
            <button style={{ display: 'flex', paddingLeft: '15px', background: 'none', fontSize: '19px', border: '0px' }}
              onClick={() => handleDeleteMC(KeyDeleteMC)}>
              <FaIcons.FaRegTimesCircle className='iconDeleteMC' />
            </button>

          }

        </td>
      </tr>
      <tr className={classColor}
        style={{
          display: u.userPreference.TipoBase === 1 ? "grid" : "",
          borderRight: "1px solid white",
          height: u.userPreference.TipoBase === 0 && Indice <= 2 ? "30px" : "48px"
        }}>
        {renderTableFirstGrid(row, rowContent, Target)}
      </tr>
    </>
  );

}
